import { FormComponent, UiComponent } from 'components';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import useModal from 'hooks/useModal';
import { EnrollQuery } from 'queries';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  ADMIN_APPLICATION_SELECT,
  ApplicationType,
  IEnrollUserCandidate,
} from 'types';

interface Props {
  user: IEnrollUserCandidate;
}

function VolunteerAddFormModal({ user }: Props) {
  const { id } = useParams<{ id: string }>();
  const { handleClose } = useModal();
  const { mutateAsync } = EnrollQuery.useAddVolunteer();
  const { mutateAsync: postEnrollResponse } =
    EnrollQuery.usePostEnrollResponse();

  const [applicationType, setApplicationType] =
    useState<ApplicationType>('STAFF');

  const handleSubmit = async () => {
    try {
      const response = await mutateAsync({
        eventId: Number(id),
        userId: user.id,
        applicationType,
      });

      await postEnrollResponse({
        enrollId: response.data.id,
        userId: user.id,
      });

      toast.success('참석자 추가가 완료되었습니다.');
      handleClose();
    } catch (error) {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
    // mutate(
    //   {
    //     eventId: Number(id),
    //     userId: user.id,
    //     applicationType,
    //   },
    //   {
    //     onSuccess: () => {
    //       toast.success('참석자 추가가 완료되었습니다.');
    //       handleClose();
    //     },
    //     onError: () => {
    //       toast.error(DEFAULT_ERROR_MESSAGE);
    //     },
    //   },
    // );
  };
  return (
    <div>
      <div
        css={{
          display: 'flex',
          flexDirection: 'row',
          gap: '16px',
          alignItems: 'center',
        }}
      >
        <p css={{ fontSize: '16px', fontWeight: 'bold' }}>{user.name}</p>

        <FormComponent.Select
          options={ADMIN_APPLICATION_SELECT}
          value={applicationType}
          handleChange={(option) =>
            setApplicationType(option as ApplicationType)
          }
        />
      </div>

      <UiComponent.Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        css={{ marginTop: '16px' }}
      >
        완료
      </UiComponent.Button>
    </div>
  );
}

export default VolunteerAddFormModal;
